import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper';

const setImgSlider = () => {
  const targetSliders = document.querySelectorAll(".js-img-slider");

  targetSliders.forEach(imgSlider => {
    var swiper = new Swiper(imgSlider, {
      modules: [Autoplay, EffectFade],
      allowTouchMove: false,
      autoplay: {
        disableOnInteraction: false,
        delay: 1000,
      },
      speed: 2000,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      slidesPerView: 'auto',
    });
  })
}

export default setImgSlider;